
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  getStayList,
  addStay,
  updateStay,
} from '@/api/stay';
import { getStayCategoryList } from '@/api/stayCategory';
import { getStayOptionTypeList } from '@/api/stayOptionType';
import { VueDaumPostcode } from 'vue-daum-postcode';
import { parseConcatNumber } from '@/utils/filters';
import OptionSelect from './components/OptionSelect.vue';
import { ElForm } from 'element-ui/types/form';
import { getOptionItemList } from '@/api/optionItem';

@Component({
  components: {
    VueDaumPostcode,
    OptionSelect,
  },
})
export default class extends Vue {
  mounted() {
    this.getStayCategoryList();
    this.getStay();
    getOptionItemList('NEWS_TITLE').then((res) => {
      this.newsTitleOptions = res.data;
    });
  }

  get selectedOptions() {
    const datas: any = [];
    this.form.optionTypes.forEach((optionType: any) => {
      optionType.options.forEach((option: any) => {
        if (option.useStatus) datas.push(option);
      });
    });
    return datas;
  }

  private isDirty = false;

  private isInit = false;

  private clearDraft() {
    this.isDirty = false;
    localStorage.removeItem('namhae_stay_form_draft');
  }

  private checkDraft() {
    const draft = localStorage.getItem('namhae_stay_form_draft');
    if (draft) {
      this.$confirm('이전에 작성 중이던 내용이 있습니다. 불러오시겠습니까?', '임시 저장 불러오기', {
        confirmButtonText: '불러오기',
        cancelButtonText: '취소',
        type: 'info',
      }).then(() => {
        try {
          const parsed = JSON.parse(draft);
          this.form = { ...this.form, ...parsed };
          this.$message.success('임시 저장된 데이터를 불러왔습니다.');
        } catch (e) {
          console.error('Failed to parse draft', e);
        }
      }).catch(() => {
        this.clearDraft();
      });
    }
  }

  @Watch('form', { deep: true })
  onFormChanged(newVal: any) {
    if (!this.isInit) return;
    this.isDirty = true;
    localStorage.setItem('namhae_stay_form_draft', JSON.stringify(newVal));
  }

  created() {
    window.addEventListener('beforeunload', this.preventNav);
  }

  destroyed() {
    window.removeEventListener('beforeunload', this.preventNav);
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.isDirty) {
      const isLogout = to.name === 'Login';
      const msg = isLogout
        ? '저장하지 않고 로그아웃 하시겠습니까?\n작성 중이던 내용은 모두 삭제되며 복구할 수 없습니다.'
        : '저장하지 않고 사이트 내에서 이동하시겠습니까?\n작성 중이던 내용은 임시 보관되지만, 변경사항이 완전히 저장되지 않을 수 있습니다.';
      if (window.confirm(msg)) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  private preventNav(event: any) {
    if (!this.isDirty) return;
    event.preventDefault();
    event.returnValue = '';
  }

  private form: any = {
    possibleTermDay: null,
    approvalStatus: true,
    name: '',
    introduction: '',
    introductionIdx: null,
    categoryIdx: null,
    address: '',
    addressDetail: '',
    addressCity: '',
    inquiryTel: '',
    basicInfo: '',
    parkingInfo: '',
    surroundInfo: '',
    additionalPeopleInfo: '',
    // refundPolicyInfo: '',
    confirmationInfo: '',
    holiday: [],
    newsList: [],
    tags: [],
    checkIn: '',
    checkOut: '',
    useStatus: true,
    images: [],
    optionTypes: [],
    formCompleteStatus: false,
  }

  private placeholderTemplate: any = {
    parkingInfo: '- 주차는 지하 주차장에 100대까지 가능합니다',
    surroundInfo: '- 주변정보 (도보로)\n남해해수욕장 5분\n남해데이트장 10분\n남해스노클링 15분\n\n- 먹거리 (도보로)\n남해먹자골목 15분',
    additionalPeopleInfo: '- 인원추가 정보입니다\n성인: 1명당 2만원\n청소년: (만 16세 미만) 1만원\n초등학생: 추가금없음',
    // refundPolicyInfo: '* 환불 안내(낮 12시 기준)\n\n취소는 아래 위약금 공제 후 환불됩니다. 신중히 결정하고 예약해주십시오.\n1. 이용 7일 전 : 10% 위약금\n2. 이용 6일 전 : 15% 위약금\n3. 이용 5일 전 : 20% 위약금\n4. 이용 4일 전 : 30% 위약금\n5. 이용 3일 전 : 50% 위약금\n6. 이용 2일 전 : 70% 위약금\n7. 이용 1일 전 ~ 당일 : 100% 위약금',
    confirmationInfo: '- 실내 흡연 불가\n- 실내 버너 사용 불가\n실내에서는 화재위험이 있어 버너는 사용이 불가합니다.',
  }

  private newsTitleOptions: any = [];

  private apiUrl = process.env.VUE_APP_BASE_API;

  private categoryList = [];

  private introductionList: any = [];

  private findAddressVisible = false;

  private fileSizeLimit = 5;

  private loading = false;

  private tagInputVisible = false;

  private tagInputValue = '';

  private optionSelectVisible = false;

  private activeTab = 'basicInfo';

  private validateInquiryTel = (rule:any, value:any, callback:any) => {
    const reqInquiryTel = /^[0-9]{2,4}-[0-9]{3,4}-[0-9]{4}$/;
    const reqInquirySafeTel = /^(070|050|060)-[0-9]{4}-[0-9]{4}$/;
    if (!reqInquiryTel.test(value) && !reqInquirySafeTel.test(value)) {
      callback(new Error('연락처 형식에 맞지 않습니다.'));
    } else {
      callback();
    }
  };

  private rules = {
    possibleTermDay: [
      { required: true, message: '식단관리 목적을 선택하세요.', trigger: ['blur', 'change'] },
    ],
    name: [
      { required: true, message: '시설명을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    categoryIdx: [
      { required: true, message: '숙소유형을 선택하세요.', trigger: ['change', 'blur'] },
    ],
    introduction: [
      { required: true, message: '숙소소개를 선택하세요.', trigger: ['change', 'blur'] },
    ],
    inquiryTel: [
      { required: true, message: '연락처를 입력하세요.', trigger: ['change', 'blur'] },
      { validator: this.validateInquiryTel, trigger: ['change', 'blur'] },
    ],
    address: [
      { required: true, message: '주소를 입력하세요.', trigger: ['change', 'blur'] },
    ],
    images: [
      { required: true, message: '이미지를 선택하세요.', trigger: ['change', 'blur'] },
    ],
    tags: [
      { required: true, message: '태그를 선택하세요.', trigger: ['change', 'blur'] },
    ],
    optionTypes: [
      { required: true, message: '시설 옵션을 선택하세요.', trigger: ['change', 'blur'] },
    ],
    checkIn: [
      { required: true, message: '체크인 시간을 입력하세요.', trigger: ['blur', 'change'] },
    ],
    checkOut: [
      { required: true, message: '체크아웃 시간을 입력하세요.', trigger: ['blur', 'change'] },
    ],
  }

  private getStay() {
    this.isInit = false;
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    this.loading = true;
    getStayList().then((res) => {
      if (res.data.length > 0) {
        this.form = {
          ...this.form,
          ...res.data[0],
        };
        // if (this.form.name === null && this.form.newsList.length === 0) {
        //   this.form.newsList.push({
        //     title: '',
        //     titleOptionIdx: null,
        //     content: '',
        //     startDate: '',
        //     endDate: '',
        //     dateRange: [],
        //   });
        // }
        if (this.form.name === null && this.form.newsList.length === 0) {
          this.form.newsList = [
            {
              title: '',
              idx: 26,
              titleOptionIdx: 26,
              content: '낭만남해에 입점하였습니다.',
              startDate: '',
              endDate: '',
              dateRange: [],
            },
          ];
        }
        if (this.form.introduction === '' || this.form.introduction === null) {
          this.form.introduction = '-';
        }
        /* if (this.form.newsList === '' || this.form.newsList[0].title === '') {
          this.form.newsList[0] = {
            content: '',
            endDate: '',
            idx: '',
            startDate: '',
            title: '🎉 낭만남해 입점',
            titleOptionIdx: '',
          };
          // this.newsTitleOptions
        } */
        if (this.form.confirmationInfo === '') {
          this.form.confirmationInfo = '미성년자는 보호자 동반없이 이용이 불가합니다';
        }
        if (this.form && this.form.tags && this.form.tags.length === 0) {
          const tagsToAdd = ['남해여행', '남해관광', '남해숙소', '뷰맛집', '남해투어'];
          tagsToAdd.forEach((tag) => {
            this.form.tags.push(tag);
          });
        }
      }
      this.form.newsList.forEach((news: any) => {
        if (news.startDate && news.endDate) {
          news.dateRange = [news.startDate, news.endDate];
        }
        // news.titleOptionIdx = this.newsTitleOptions[0].idx;
      });
      getStayOptionTypeList().then((res2) => {
        this.form.optionTypes = res2.data;
        res2.data.forEach((optionType: any, index: number) => {
          const options: any = [];
          optionType.options.forEach((option: any) => {
            const optionIdx = this.form.options.findIndex((x: any) => x.optionIdx === option.idx);
            if (optionIdx < 0) {
              options.push({
                typeIdx: optionType.idx,
                optionIdx: option.idx,
                name: option.name,
                useStatus: false,
              });
            } else {
              options.push({
                idx: this.form.options[optionIdx].idx,
                typeIdx: optionType.idx,
                optionIdx: option.idx,
                name: option.name,
                useStatus: this.form.options[optionIdx].useStatus,
              });
            }
          });
          this.form.optionTypes[index].options = options;
        });
        this.loading = false;
        this.$nextTick(() => {
          this.isInit = true;
          this.checkDraft();
        });
      });
      this.getIntroductionList();
    });
  }

  private getStayCategoryList() {
    getStayCategoryList().then((res) => {
      this.categoryList = res.data;
    });
  }

  private getIntroductionList() {
    getOptionItemList('STAY_INTRODUCE').then((res) => {
      if (res.data.length > 0) {
        this.introductionList = res.data.map((item: any) => {
          if (this.form.name !== '' && this.form.name !== null) item.name = item.name.replaceAll('OOO', this.form.name);
          return item;
        });
      }
      // this.introductionList = res.data;
    });
  }

  private formatPhoneNumber() {
    const regex = /^(\d{3})[-]?(\d{4})[-]?(\d{4})$/;
    if (regex.test(this.form.inquiryTel)) {
      this.form.inquiryTel = this.form.inquiryTel.replace(
        /^(\d{3})(\d{4})(\d{4})$/,
        '$1-$2-$3',
      );
    }
  }

  private replaceIntroduction() {
    this.getIntroductionList();
  }

  private handleFindAddress() {
    this.findAddressVisible = !this.findAddressVisible;
  }

  private handleCompleteFindAddress(data: any) {
    this.handleFindAddress();
    this.form.address = data.roadAddress;
    this.form.addressCity = data.bname1;
    this.form.addressDetail = '';
  }

  private filterInquiryTel() {
    this.form.inquiryTel = parseConcatNumber(this.form.inquiryTel);
  }

  private handleBeforeUpload(uploadFile:File) {
    const fileSizeLimitByMb = this.fileSizeLimit * 1024 * 1024;
    const isImageFile = uploadFile.type.split('/')[0] === 'image';
    if (!isImageFile) {
      this.$message.warning('이미지 파일만 업로드 가능합니다.');
      return false;
    }
    if (uploadFile.size > fileSizeLimitByMb) {
      this.$message.warning(`파일 업로드 최대용량은 ${this.fileSizeLimit}MB입니다.`);
      return false;
    }
    return true;
  }

  private handleRemoveImageFile(file: any) {
    const index = this.form.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index > -1) this.form.images.splice(index, 1);
  }

  private handleSuccessUploadImageFile(res: any) {
    this.form.images.push({ fileUid: res.uid });
  }

  private handleClickLeftFile(file: any) {
    const index = this.form.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index > 0) {
      this.form.images.splice(index - 1, 0, this.form.images.splice(index, 1)[0]);
    }
  }

  private handleClickRightFile(file: any) {
    const index = this.form.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index < this.form.images.length - 1) {
      this.form.images.splice(index + 1, 0, this.form.images.splice(index, 1)[0]);
    }
  }

  private handleClickSave() {
    (this.$refs.stayForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.$confirm('정말 숙소정보를 저장하시겠습니까?', '숙소 정보 저장', {
          confirmButtonText: '저장',
          cancelButtonText: '취소',
          type: 'info',
        }).then(() => {
          this.convertOptions();
          this.form.formCompleteStatus = true;
          this.form.possibleTermDay = 90;
          if (this.form.idx) {
            updateStay(this.form.idx, this.form).then(() => {
              this.clearDraft();
              this.$message.success('숙소 정보가 저장되었습니다.');
              this.getStay();
            });
          } else {
            addStay(this.form).then(() => {
              this.clearDraft();
              this.$message.success('숙소 정보가 저장되었습니다.');
              this.getStay();
            });
          }
        });
      } else {
        this.$message.warning('미입력된 필드가 존재합니다.');
      }
    });
  }

  private handleClickTmpSave() {
    this.$confirm('현재 숙소정보를 임시 저장하시겠습니까? ※ 임시 저장시 사용자에게 노출되지 않습니다.', '임시 저장', {
      confirmButtonText: '저장',
      cancelButtonText: '취소',
      type: 'info',
    }).then(() => {
      this.convertOptions();
      this.form.formCompleteStatus = false;
      this.form.possibleTermDay = 90;
      if (this.form.idx) {
        updateStay(this.form.idx, this.form).then(() => {
          this.clearDraft();
          this.$message.success('숙소 정보가 임시 저장되었습니다.');
          this.getStay();
        });
      } else {
        addStay(this.form).then(() => {
          this.clearDraft();
          this.$message.success('숙소 정보가 임시 저장되었습니다.');
          this.getStay();
        });
      }
    });
  }

  private handleClickAddTag() {
    this.tagInputVisible = !this.tagInputVisible;
  }

  private handleAddTag() {
    let inputValue = this.tagInputValue;
    inputValue = inputValue.trim();
    if (inputValue && this.form.tags.length <= 5) {
      this.form.tags.push(inputValue);
    }
    this.tagInputVisible = false;
    this.tagInputValue = '';
  }

  private handleRemoveTag(index: number) {
    this.form.tags.splice(index, 1);
  }

  private convertOptions() {
    let options: any = [];
    this.form.optionTypes.forEach((optionType: any) => {
      options = options.concat(optionType.options);
    });
    this.form.options = options;
  }

  private handleAddNews() {
    this.form.newsList.push({
      title: '',
      titleOptionIdx: this.newsTitleOptions[0].idx,
      content: '',
      startDate: '',
      endDate: '',
      dateRange: [],
    });
  }

  private handleDeleteNews(index: number) {
    this.form.newsList.splice(index, 1);
  }

  private handleNewsTitle(index: number) {
    if (this.form.news[index].title === '직접입력') {
      this.form.news[index].title = '';
      this.form.news[index].titleDirectFlag = true;
    } else {
      this.form.news[index].titleDirectFlag = false;
    }
  }

  /* eslint-disable */
  private handleChangeNewsDateRange(index: number) {
    const news = this.form.newsList[index];
    if (news.dateRange && news.dateRange.length === 2) {
      news.startDate = news.dateRange[0];
      news.endDate = news.dateRange[1];
    } else {
      news.startDate = '';
      news.endDate = '';
    }
  }

  private handleChangeNewsTitle(index: number) {
    const news = this.form.newsList[index];
    if (news.titleOptionIdx === 27) {
      news.title = '';
    } else {
      const titleIndex = this.newsTitleOptions.findIndex((option: any) => option.idx === news.titleOptionIdx);
      const titleOption = this.newsTitleOptions[titleIndex];
      news.title = titleOption.name;
    }
  }
  /* eslint-enable */

  private handleMakerFocus() {
    if (this.form.surroundInfo === '' || this.form.surroundInfo === null) this.form.surroundInfo = '•';
  }

  private handleMakerBlur() {
    if (this.form.surroundInfo === '•') this.form.surroundInfo = '';
  }

  private handleMaker(e: any, param: string) {
    if (e.key === 'Enter' && this.form.surroundInfo[this.form.surroundInfo.length - 1] !== '•') {
      if (param === 'etc') {
        this.form.confirmationInfo += '•';
      } else {
        this.form.surroundInfo += '•';
      }
    } else if (e.key === 'Backspace' && this.form.surroundInfo === '') {
      if (param === 'etc') {
        this.form.confirmationInfo = '•';
      } else {
        this.form.surroundInfo = '•';
      }
    }
  }

  private handleIntroductionChange() {
    // console.log(item);
    // this.form.introduction = item;
  }
}
